import { useState } from "react"
import { Toolbar } from "@/components/organisms"
import { DashboardCards } from "./DashboardCards"

const Dashboard = () => {
  // Estado para os filtros de data (seguindo o padrão da Mentorings.tsx)
  const [dateRange, setDateRange] = useState({
    from: `01/01/${new Date().getFullYear()}`,
    to: new Date().toISOString().split("T")[0].split("-").reverse().join("/"),
  })

  // Mock de dados - Aqui você poderia futuramente usar um fetchMentorings
  // e calcular esses valores com base no retorno da API
  const dashboardData = {
    mentoria: {
      especialista: 50,
      principal: 25,
      giants: 10,
    },
    sessoes: {
      online: 120,
      inCompany: 80,
    },
    performance: [85, 90, 70, 95, 80],
  }

  const breadcrumbItems = [
    {
      href: "/",
      label: "Início",
    },
    {
      href: "/dashboard",
      label: "Dashboard",
      isCurrent: true,
    },
  ]

  const handleDateChange = (type: "from" | "to", value: string) => {
    setDateRange((prev) => ({ ...prev, [type]: value }))
    // Lógica adicional de refetch pode ser disparada aqui quando a data estiver completa
  }

  return (
    <section className="flex flex-col gap-4">
      <div
        data-state="open"
        className={
          "flex flex-col gap-4 data-[state=open]:duration-700 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-top-5"
        }
      >
        <Toolbar breadcrumbItems={breadcrumbItems} />

        <div className="flex flex-col">
          {/* Seção principal com o mesmo padding da listagem de mentorias */}
          <section className="px-8 pb-10 pt-20">
            <DashboardCards
              data={dashboardData}
              dateRange={dateRange}
              onDateChange={handleDateChange}
            />
          </section>
        </div>
      </div>
    </section>
  )
}

export default Dashboard
